import { CompositionStore } from "../../store/CompositionStore";
import { TimelineStore } from "../../store/TimelineStore";

export function convertUnitsToTime(time: number): number {
  const timelineWidth = TimelineStore.width;
  const timelineZoom = TimelineStore.zoom;
  const duration = CompositionStore.duration;

  const ratio = (timelineWidth / duration) * timelineZoom;
  return time / ratio;
}
